
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeadingCUpProposal as ObiHeadingCUpProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heading-c-up-proposal.js';
 
 
 

 
 export const ObiHeadingCUpProposal = createComponent({
   react: React,
   tagName: 'obi-heading-c-up-proposal',
   elementClass: ObiHeadingCUpProposalElement,
   events: {
     
   }
  });
 
 